import * as React from 'react';
import {useEffect, useState, VFC} from 'react';
import styles from './index.less';
import {getTopicInfo, TopicModule, TopicResponseData, TopicShareResponse, getTopicShareInfo} from '@/services/pages/channel/channel.client';
import {ACTIONS, useDispatchStore} from '../Store';
import {TopCardImg} from "@/interfaces/specialDisease";
import {
    SELF_TOPIC_BAR,
    SELF_TOPIC_CONTAINER,
    SELF_TOPIC_CONTAINER_TYPE_H,
    SELF_TOPIC_CONTAINER_TYPE_V,
    SELF_TOPIC_CONTENT_NAME,
    SELF_TOPIC_CONTENT_TYPE_FLOW_BIG,
    SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL,
    SELF_TOPIC_CONTENT_TYPE_HORIZONTAL,
    SELF_TOPIC_HEAD_NAME,
    SELF_TOPIC_IMAGE_NAME,
    SELF_TOPIC_IMAGE_TYPE_BANNER,
    SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN,
    SELF_TOPIC_IMAGE_TYPE_GOLD_ICON,
    SELF_TOPIC_IMAGE_TYPE_HORIZONTAL,
    SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN,
    SELF_TOPIC_TOFU_CUBE_NAME,
} from "@/dicts/modelConsts";
import SelfTopicContentHorizontal from "@/pages/specialDisease/hotContent";
import SelfTopicContentFlowSmall from "@/components/flowSmall";
import SelfTopicTofuText from "@/components/tofuText";
import SelfTopicImgDoubleColumn from "@/components/doubleColumn";
import DiseaseGoldIcons from "@/pages/specialDisease/goldIcons";
import SelfTopicImageHorizontal from "@/components/imgHorizontal";
import DiseaseBannerSwipe from "@/pages/specialDisease/swiper";
import SelfTopicContentFlowBig from "@/components/flowBig";
import SelfTopicContainerVertical from "@/components/containerVertical";
import SelfTopicBottomBar from "@/components/bottomBar";
import SelfTopicImgSpecialDoubleColumn from "@/components/specialDoubleColumn";
import DiseaseTopCard from "@/pages/specialDisease/topcard";
import SelfTopicContainerHorizontal from "@/components/containerHorizontal";
import {useSearchParams} from "@/hooks/router";
import {shareBdBox} from "@/utils/share";
import share from '@/utils/share';
import { useLocation } from "react-router-dom";
import { logVewReport } from "@/utils/ubcUtils";


interface InfoQuery {
    id: string;
    sa?: string;
    sf_ch?: string;
    preview?: boolean;
}


const Channel: VFC = () => {
    // eslint-disable-next-line global-require
    const ua = require('@searchfe/user-agent');
    const [sfRef, setSfRef] = useState<string>();
    const [loadStatus, setLoadStatus] = useState(true);
    const [infoLoadStatus, setInfoLoadStatus] = useState(false); // 接口状态
    const dispatch = useDispatchStore();

    const  param = useSearchParams();

    // 获取卡片信息
    const [infoQuery, setInfoQuery] = useState<InfoQuery>();

    // 卡片
    const [topicInfos, setTopicInfos] = useState<TopicResponseData>();
    // 头图
    const [topCardInfo, setTopCardInfo] = useState<TopCardImg>({});

    const [bottomBarInfo, setbottomBarInfo] = useState<TopicModule>({});

    const mPage = useLocation().pathname;

    // 分享信息
    const [shareInfos, setShareInfos] = useState<TopicShareResponse>();

    useEffect(
        () => {
            if (!loadStatus && dispatch && !infoLoadStatus) {
                dispatch({
                    type: ACTIONS.SET_SKELETON_STATUS,
                    payload: loadStatus
                });
            }
        },
        [loadStatus, infoLoadStatus, dispatch]
    );

    useEffect(
        () =>  {
            fetchInfo(
                infoQuery?.id,
                infoQuery?.sa,
                infoQuery?.sf_ch,
                infoQuery?.preview
            )
        },
        [infoQuery]
    );

    const fetchAuthInfo = async () => {
        try {
            const shareInfo = await getTopicShareInfo({
                wxAppKey: 'netHospitalService',
                url: window.location.href,
            });
            setShareInfos(shareInfo);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    };

    useEffect(
        () => {
            setInfoQuery({
                id: param.id,
                sa: param.sa,
                sf_ch: param.sf_ch,
                preview: param.preview
            });
            setSfRef(param.sf_ch);
        },
        []
    );

    useEffect(
        () => {
            if (ua.isWeixinApp()) {
                fetchAuthInfo();
            }
        },
        [ua]
    );

    useEffect(
        () => {
            if (ua.isWeixinApp() && shareInfos?.appId) {
                share({
                    title: topicInfos?.channelShareTitle,
                    content: topicInfos?.channelShareSubTitle,
                    imageUrl: topicInfos?.channelShareLogo,
                    url: shareInfos?.url,
                }, {
                    debug: false,
                    appId: shareInfos?.appId ?? '',
                    timestamp: shareInfos?.timestamp ?? '',
                    nonceStr: shareInfos?.nonceStr ?? '',
                    signature: shareInfos?.signature ?? '',
                });
            } else {
                shareBdBox({
                    title: topicInfos?.channelShareTitle,
                    content: topicInfos?.channelShareSubTitle,
                    imageUrl: topicInfos?.channelShareLogo,
                });
            }
        },
        [shareInfos, shareInfos?.appId, shareInfos?.nonceStr,
            shareInfos?.signature, shareInfos?.timestamp, shareInfos?.url, topicInfos, ua]
    );


    const fetchInfo = async (id?: string, sa?: string, sf_ch?: string, preview?: boolean) => {
        if (!id) {
            return
        }
        try {
            // Loading.show();
            const result = await getTopicInfo({
                id: id, sa: sa, sf_ch: sf_ch, preview : preview
            });
            // Loading.hide();
            // setFollows(result.myFollowSections);
            // setSubCommunities(result.sectionList);

            setLoadStatus(false);
            setInfoLoadStatus(true);

            if (!result) {
                return
            }

            // 渲染头图
            result.moduleList.map(
                (model) => {
                    const field = model && model.itemList && model.itemList[0].fieldValue;
                    model.moduleEnName == SELF_TOPIC_HEAD_NAME ? setTopCardInfo({
                            id: infoQuery?.id,
                            sf_ch: infoQuery?.sf_ch,
                            selfLogo: field?.logo,
                            selfName: field?.selfName,
                            bgImage: field?.bgImage,
                            hasMask: field?.hasMask,
                            thirdLogo: field?.thirdLogo,
                            thirdName: field?.thirdName,
                            title: field?.title,
                            titleImage: field?.titleImage,
                            readNum: field?.readNum,
                            moduleId: model.moduleId,
                        }) :
                        model.moduleEnName == SELF_TOPIC_BAR && model.itemList
                            ? setbottomBarInfo(model)
                            : ""
                }
            );

            // 渲染卡片
            setTopicInfos(result);

            logVewReport(mPage, "page", sfRef, result.channelId)

        } catch (error) {
            console.log(error);
            // Loading.hide();
        }

    };


    // 渲染
    const renderInfo = () => {

        return (
            <div>
                {
                    topicInfos?.moduleList.map(
                        (model) => {
                            switch (model.moduleEnName) {
                                case SELF_TOPIC_IMAGE_NAME:
                                    switch (model.moduleStyle) {
                                        case SELF_TOPIC_IMAGE_TYPE_BANNER:
                                            return (
                                                model?.itemList?.length ?
                                                    <div className={(model.isShowTitle == 1 && (model.moduleName || model.moduleSubTitle))
                                                        ? styles.cardBg : styles.cardTopBg}>
                                                        <DiseaseBannerSwipe
                                                            page={mPage}
                                                            sfRef={sfRef}
                                                            bannersModel={model}
                                                        />
                                                    </div>
                                                    : null
                                            );
                                        case SELF_TOPIC_IMAGE_TYPE_HORIZONTAL:
                                            return(
                                                model?.itemList?.length ?
                                                    <div className={styles.cardImgHBg}>
                                                        <SelfTopicImageHorizontal page={mPage} sfRef={sfRef} infos={model}/>
                                                    </div>
                                                    : null
                                            );
                                        case SELF_TOPIC_IMAGE_TYPE_GOLD_ICON:
                                            return(
                                                model?.itemList?.length ?
                                                    <div className={styles.cardBg}>
                                                        <DiseaseGoldIcons
                                                            page={mPage}
                                                            sfRef={sfRef}
                                                            goldIcons={{
                                                                channelId: model.channelId,
                                                                golds: model.itemList,
                                                                moduleMaxColumns: model.moduleMaxColumns
                                                        }}/>
                                                    </div>
                                                    : null
                                            );
                                        case SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN:
                                            return(
                                                model?.itemList?.length ?
                                                    <div className={styles.cardBg}>
                                                        <SelfTopicImgDoubleColumn page={mPage} sfRef={sfRef} infos={model}/>
                                                    </div>
                                                    : null
                                            );
                                        case SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN:
                                            return(
                                                model?.itemList?.length ?
                                                    <div className={styles.cardBg}>
                                                        <SelfTopicImgSpecialDoubleColumn page={mPage} sfRef={sfRef} infos={model}/>
                                                    </div>
                                                    : null
                                            );
                                    }
                                    break;
                                case SELF_TOPIC_TOFU_CUBE_NAME:
                                    return(
                                        model?.itemList?.length ?
                                            <div className={styles.cardBg}>
                                                <SelfTopicTofuText page={mPage} sfRef={sfRef} infos={model}/>
                                            </div>
                                            : null
                                    );
                                case SELF_TOPIC_CONTENT_NAME:
                                    switch (model.moduleStyle) {
                                        case SELF_TOPIC_CONTENT_TYPE_HORIZONTAL:
                                            return(
                                                model?.itemList?.length ?
                                                    <div className={styles.cardBg}>
                                                        <SelfTopicContentHorizontal page={mPage} sfRef={sfRef} infos={model}/>
                                                    </div>
                                                    : null
                                            );
                                        case SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL:
                                            return(
                                                model?.itemList?.length ?
                                                    <div className={styles.cardBg}>
                                                        <SelfTopicContentFlowSmall page={mPage} sfRef={sfRef} infos={model}/>
                                                    </div>
                                                    : null
                                            );
                                        case SELF_TOPIC_CONTENT_TYPE_FLOW_BIG:
                                            return(
                                                model?.itemList?.length ?
                                                    <div className={styles.cardBg}>
                                                        <SelfTopicContentFlowBig page={mPage} sfRef={sfRef} infos={model}/>
                                                    </div>
                                                    : null
                                            );
                                    }
                                    break;
                                case SELF_TOPIC_CONTAINER:
                                    switch (model.moduleStyle) {
                                        case SELF_TOPIC_CONTAINER_TYPE_H:
                                            return(
                                                model?.subModuleList?.length ?
                                                    <div className={styles.cardBg}>
                                                        <SelfTopicContainerHorizontal page={mPage} infos={model}/>
                                                    </div>
                                                    : null
                                            );
                                        case SELF_TOPIC_CONTAINER_TYPE_V:
                                            return(
                                                model?.subModuleList?.length ?
                                                    <div className={styles.cardContentVBg}>
                                                        <SelfTopicContainerVertical page={mPage} infos={model}/>
                                                    </div>
                                                    : null
                                            );
                                    }
                                    break;
                            }
                        }
                    )
                }
            </div>
        )
    };

    // 渲染头图
    const renderTopCard = () => {
        return (
            <div>
                <DiseaseTopCard infos={topCardInfo}/>
            </div>
        )
    };

    const renderBottomBar =() => {
        return (
            <div>
                <SelfTopicBottomBar page={mPage} sfRef={sfRef} infos={bottomBarInfo}/>
            </div>
        )
    };


    return (
        <div className={styles.pageContainer}>

            {/*头图*/}
            {
                topCardInfo?.moduleId ? renderTopCard()
                    : <div className={styles.topMargin}/>
            }

            <div
                className={styles.bgParent}
                style={{
                    marginBottom: bottomBarInfo?.itemList ? 60 : 0
                }}
            >

                <div
                    className={styles.bgBelow}
                >

                </div>

                <div
                    className={topCardInfo?.moduleId ? styles.belowTopImgParentMargin : styles.belowTopImgParent}
                >
                    {renderInfo()}

                </div>

                <div
                    className={styles.bottomEndText}
                >
                    到底了～
                </div>

            </div>

            {
                bottomBarInfo?.itemList ? renderBottomBar() : null
            }

        </div>
    );
};

export default Channel;
